export default "__VITE_ASSET__b25bc775__"